/* ===== Muever — global chrome interactions (header drawer, sticky, etc.) ===== */
(function () {
  'use strict';

  /* ---- sticky header shadow ---- */
  var header = document.querySelector('[data-mv-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- mobile drawer ---- */
  var drawer = document.querySelector('[data-mv-drawer]');
  var openBtn = document.querySelector('[data-mv-burger]');
  if (drawer && openBtn) {
    var open = function () { drawer.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
    var close = function () { drawer.classList.remove('is-open'); document.body.style.overflow = ''; };
    openBtn.addEventListener('click', open);
    drawer.querySelectorAll('[data-mv-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  }
})();
